module.exports = __webpack_public_path__ + "img/1F1F9-1F1EF.38fe2121.svg";